import React from "react";
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import "./Breadcrumb.scss";

const Breadcrumb = ({ category, loadProducts }) => {
  if (!category) {
    return <div />;
  }

  if (category.id < 0) {
    return (
      <Breadcrumbs
        className="breadcrumb"
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="fil d'ariane"
      >
        <Typography color="text.primary" fontWeight={600}>{category.name}</Typography>
      </Breadcrumbs>
    );
  }

  const items = [];

  if (category.parent && category.parent.parent) {
    items.push(
      <Link
        key={category.parent.parent.id}
        component="button"
        underline="hover"
        color="inherit"
        className="breadcrumb-link"
        onClick={() => loadProducts(category.parent.parent)}
      >
        {category.parent.parent.name}
      </Link>
    );
  }

  if (category.parent) {
    items.push(
      <Link
        key={category.parent.id}
        component="button"
        underline="hover"
        color="inherit"
        className="breadcrumb-link"
        onClick={() => loadProducts(category.parent)}
      >
        {category.parent.name}
      </Link>
    );
  }

  items.push(
    <Typography key={category.id} color="text.primary" fontWeight={600}>
      {category.name}
    </Typography>
  );

  return (
    <Breadcrumbs
      className="breadcrumb"
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="fil d'ariane"
    >
      {items}
    </Breadcrumbs>
  );
};

export default Breadcrumb;
